import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Modal } from 'antd'
import { Add, Cancel } from 'components/UI'
import { useMenuTitle, usePrevious } from 'utils/hooks'
import FinanceTagForm from '../FinanceTagForm'

const AddFinanceTag = ({ show, confirmLoading, hideHandler, submitHandler, innerRef }) => {
  const { formatMessage } = useIntl()

  const title = useMenuTitle({ name: 'tags' })
  const prevShow = usePrevious(show)

  useEffect(() => {
    if (prevShow !== show && innerRef.current) {
      innerRef.current.resetFields()
    }
  }, [innerRef, prevShow, show])

  return (
    <Modal
      wrapClassName="tag-modal"
      title={`${formatMessage({ id: 'button.add' })} ${title}`}
      open={show}
      onCancel={hideHandler}
      destroyOnHidden
      footer={[
        <Cancel key={`_${0}`} onClick={hideHandler} />,
        <Add loading={confirmLoading} form="tagForm" key="submit" htmlType="submit" />,
      ]}
    >
      <FinanceTagForm show={show} submitHandler={submitHandler} ref={innerRef} />
    </Modal>
  )
}

export default React.forwardRef((props, ref) => <AddFinanceTag innerRef={ref} {...props} />)
